import { useMutation, useQueryClient } from "react-query";
import { authInstance } from "apis";

interface Dto {
  isClosed: boolean;
}

interface Props {
  onSuccess: () => void;
}

const useEditCompanyIsClosed = ({ onSuccess }: Props) => {
  const queryClient = useQueryClient();

  const fetcher = async ({ isClosed }: Dto) => {
    const { data } = await authInstance.patch("company/isClosed", { isClosed });
    return data;
  };

  const { mutate } = useMutation(fetcher, {
    onSuccess: () => {
      queryClient.invalidateQueries(["company/me"]);
      onSuccess();
    },
  });

  return { mutate };
};

export default useEditCompanyIsClosed;
